var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 20,
    viewBox: "0 0 37 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.34784 0 4.80432 1.05359 2.92896 2.92896C1.05359 4.80432 0 7.34784 0 10C0 12.6522 1.05359 15.1957 2.92896 17.071C4.80432 18.9464 7.34784 20 10 20V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.9891 0 13.8968 0.790193 15.3033 2.19672C16.7099 3.60324 17.5 5.51088 17.5 7.5C17.5 9.48912 16.7099 11.3968 15.3033 12.8033C13.8968 14.2098 11.9891 15 10 15V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 0C26.176 0 23.6324 1.05359 21.7571 2.92896C19.8817 4.80432 18.8281 7.34784 18.8281 10C18.8281 12.6522 19.8817 15.1957 21.7571 17.071C23.6324 18.9464 26.176 20 28.8281 20V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 0C30.8172 0 32.7248 0.790193 34.1313 2.19672C35.5379 3.60324 36.3281 5.51088 36.3281 7.5C36.3281 9.48912 35.5379 11.3968 34.1313 12.8033C32.7248 14.2098 30.8172 15 28.8281 15V0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.0be57a4875d861401fe5c9ad1149320a.svg";
export { ForwardRef as ReactComponent };